import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { getColumns } from './columns';
import { Collapse, TableTmovShipper } from './styles';

const TarifaClienteTmov = ({ tarifas, tipoTarifa }) => {
  const lastIndex = tarifas.length - 1;
  const columnsTable = getColumns(tipoTarifa, lastIndex);
  const { Panel } = Collapse;

  return (
    <>
      <Col span={24}>
        <Collapse defaultActiveKey={['2']} expandIconPosition="right">
          <Panel header="Tarifa Clientes TMOV" key="1">
            <Row justify="space-between">
              <TableTmovShipper
                dataSource={
                  tarifas.length &&
                  tarifas.map((tarifa, index) => ({
                    ...tarifa,
                    key: `tarifa_${index}`,
                  }))
                }
                columns={columnsTable}
                pagination={false}
              />
            </Row>
          </Panel>
        </Collapse>
      </Col>
    </>
  );
};

TarifaClienteTmov.propTypes = {
  tarifas: PropTypes.arrayOf(PropTypes.object).isRequired,
  tipoTarifa: PropTypes.string.isRequired,
};

export default TarifaClienteTmov;
